import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import "./mainhomesection.css";

const MainHomeSection = () => {
  const Goldcontainer = useRef();
  const Silvercontainer = useRef();

  const [goldSymbol, setGoldSymbol] = useState("FX_IDC:XAUINRG");
  const [silverSymbol, setSilverSymbol] = useState("FX_IDC:XAGINRK");

  const [goldPrice, setGoldPrice] = useState(null); // formatted

  const [silverPrice, setSilverPrice] = useState(null); // formatted

  // Fetch GOld Price
  useEffect(() => {
    const fetchGold = async () => {
      try {
        const res = await axios.get("https://api.gold-api.com/price/XAU");
        const pricePerOunce = parseFloat(res.data.price);

        // Convert to price per gram in INR
        const rawPrice = (pricePerOunce / 28.3495) * 85;

        // Apply the 0.9385 multiplier
        const adjustedPrice = rawPrice * 0.9385;

        // Format it
        const formattedPrice = adjustedPrice.toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
          maximumFractionDigits: 2,
        });

        setGoldPrice(formattedPrice);
      } catch (error) {
        console.error("Error fetching gold rate:", error);
      }
    };

    fetchGold();
    const interval = setInterval(fetchGold, 5000);
    return () => clearInterval(interval);
  }, []);

  // Fetch Silver Price
  useEffect(() => {
    const fetchSilver = async () => {
      try {
        const res = await axios.get("https://api.gold-api.com/price/XAG");
        const pricePerOunce = parseFloat(res.data.price);

        // Convert to price per kg in INR
        const rawPrice = (pricePerOunce / 28.3495) * 85 * 1000;

        // Apply the 0.9385 multiplier
        const adjustedPrice = rawPrice * 0.937;

        // Format it
        const formattedPrice = adjustedPrice.toLocaleString("en-IN", {
          style: "currency",
          currency: "INR",
          maximumFractionDigits: 2,
        });

        setSilverPrice(formattedPrice);
      } catch (error) {
        console.error("Error fetching silver rate:", error);
      }
    };

    fetchSilver();
    const interval = setInterval(fetchSilver, 5000);
    return () => clearInterval(interval);
  }, []);

  // Load TradingView charts
  useEffect(() => {
    const loadTradingViewScript = (symbol, container) => {
      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "allow_symbol_change": false,
          "calendar": false,
          "details": false,
          "hide_side_toolbar": true,
          "hide_top_toolbar": true,
          "hide_legend": true,
          "hide_volume": true,
          "hotlist": false,
          "interval": "D",
          "locale": "en",
          "save_image": false,
          "style": "1",
          "symbol": "${symbol}",
          "theme": "dark",
          "timezone": "Etc/UTC",
          "backgroundColor": "#0F0F0F",
          "gridColor": "rgba(242, 242, 242, 0.06)",
          "watchlist": [],
          "withdateranges": false,
          "compareSymbols": [],
          "studies": [
            "Volume@tv-basicstudies"
          ],
          "autosize": true
        }`;
      container.current.appendChild(script);
    };

    loadTradingViewScript(goldSymbol, Goldcontainer);
    loadTradingViewScript(silverSymbol, Silvercontainer);
  }, [goldSymbol, silverSymbol]);

  return (
    <section className="mainhome-section">
      <div className="container">
        <div className="row">
          <div className="main-box flex">
            <div className="box">
              <div className="content">
                <div className="tagline">
                  <p>
                    <img src="./img/accuracy.png" alt="accuracy_icon" />
                    Real-Time Gold, Silver & Currency Prices
                  </p>
                </div>
                <h2>
                  Live Gold & Silver Rates, Currency Converter, and Market News —{" "}
                  <span>"All in One Place"</span>
                </h2>
                <p>
                  Real-time market data, advanced analytics, and intelligent alerts
                  for gold, silver, platinum, and palladium investments.
                </p>
                <div className="btn">
                  <NavLink to="/gold">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-trending-up h-5 w-5 mr-2"
                    >
                      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                      <polyline points="16 7 22 7 22 13" />
                    </svg>
                    View Live Prices
                  </NavLink>
                  <NavLink to="/news">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-trending-up h-5 w-5 mr-2"
                    >
                      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                      <polyline points="16 7 22 7 22 13" />
                    </svg>
                    View Live Prices
                  </NavLink>
                </div>
              </div>
            </div>

            <div className="box">
              <div className="content">
                <div className="top-heading">
                  <h3>Live Markets</h3>
                  <span className="animated">Live</span>
                </div>

                <div className="main-card">
                  <div className="card">
                    <div className="card-content">
                      <div className="top-heading">
                        <h4 className="gold">Gold (XAUINR)</h4>
                        <span className="price">
                          {goldPrice}
                        </span>
                      </div>
                      <div
                        className="tradingview-widget-container"
                        ref={Goldcontainer}
                        style={{ height: "100%", width: "100%" }}
                      >
                        <div
                          className="tradingview-widget-container__widget"
                          style={{ height: "100%", width: "100%" }}
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-content">
                      <div className="top-heading">
                        <h4 className="silver">Silver (XAGINR)</h4>
                        <span className="price">
                          {silverPrice}
                        </span>
                      </div>
                      <div
                        className="tradingview-widget-container"
                        ref={Silvercontainer}
                        style={{ height: "100%", width: "100%" }}
                      >
                        <div
                          className="tradingview-widget-container__widget"
                          style={{ height: "100%", width: "100%" }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainHomeSection;
